import * as React from 'react';
import { connect } from 'react-redux';
import { Button, OverlayTrigger, Popover, Row, Col, CloseButton, Tooltip, Overlay } from 'react-bootstrap';
import PopoverContent from 'react-bootstrap/PopoverContent';
import PopoverTitle from 'react-bootstrap/PopoverTitle';
import '@fortawesome/fontawesome-free/css/all.css';
import 'font-awesome/css/font-awesome.css';
import './tooltiptoggle.css';
import { IFormioValidationError } from '../../../common/sharedTypes';
const $ = require('jquery');
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.4/css/fontawesome.min.css" integrity="sha384-jLKHWM3JRmfMU0A5x5AkjWkw/EYfGUAGagvnfryNV3F9VqM98XiIH7VBGVoxVSc7"></link>


export interface IToggleTooltipProps {
  messageText?: string;
  validations?: IFormioValidationError[];
  placement: string;
  type: string;
  iconClass: string;
}
export interface IToggleTooltipState {  
  showOverlay: boolean;
  target: any;
}
const initialState: IToggleTooltipState = {
  showOverlay: false,
  target:null
};
class ToggleTooltip extends React.Component<
  IToggleTooltipProps,
  IToggleTooltipState
> {
  windowRef: any;
  refy: any;
  

  public constructor(props: IToggleTooltipProps) {
    super(props);
    this.state = initialState;
  }

  onClosingClick = () => {
    //(this.state.mapComponents.view as any).destroy();
    this.setState({ showOverlay: false });
    console.log('comments closed');
  };

  componentDidMount() {
    
  }

  onToggle = () => {
    this.setState(state => ({
      showOverlay: !state.showOverlay,
    }));
  }

  handleClick = e => {
    this.setState({ target: e.target, showOverlay: !this.state.showOverlay });
  };
  

  public render() {
    const placement = this.props.placement ?? "top";
    const {messageText} = this.props;
    let validationList: any = null;
    if(this.props.validations && this.props.validations.length > 0) {
        validationList = (
            this.props.validations.map((v, idx) => {
                const iconClass = v.type=='error' 
                  ? 'fa-solid fa-circle-exclamation tterror' 
                  : v.type=='warning' 
                    ? 'fas fa-exclamation-triangle ttwarning' 
                    : ''
                return (
                <React.Fragment>
                    <i className={iconClass}></i> {'  '}
                    {v.message}
                    <br/>
                </React.Fragment>
                );
            })
        )
    }
    return (

      <React.Fragment>
        <OverlayTrigger
          trigger='click'
          key={`commentOverlay${messageText}`}
          placement={
            placement == 'right'
              ? 'right'
              : placement == 'left'
                ? 'left'
                : placement == 'bottom'
                  ? 'bottom'
                  : 'top'
          }
          rootClose
          show={this.state.showOverlay}
          onToggle={this.onToggle}
          container={this.refy}
          overlay={
            <Popover
              id={`popover-positioned-${placement}`}
              className='popComments'
            >
              <PopoverTitle as='h3'>
                <Row>
                  <Col>Details</Col>                  
                  <Col>
                    <CloseButton
                      onClick={this.onToggle}
                    />
                  </Col>
                </Row>
              </PopoverTitle>
              <PopoverContent>
                {validationList || messageText}
              </PopoverContent>
            </Popover>
          }
        > 
        <i className={this.props.iconClass} ref={(comp) => {
            this.refy = comp;
            }}></i>
        </OverlayTrigger>
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ToggleTooltip);
